import { Snowflake, Moon, Candy, Clock, Footprints, Wind, Sparkles, Utensils, Flame, Gift, HeartCrack, TrafficCone, UserX, Siren } from "lucide-react";

const Hair = () => (
  <svg viewBox="0 0 100 40" className="absolute top-[4%] left-[18%] w-[64%]" aria-hidden>
    {[12, 22, 32, 42, 52, 62, 72, 82].map((x, i) => (
      <path key={x} d={`M${x} 38 q${i % 2 ? 8 : -8} -14 ${i % 2 ? -4 : 6} -30 q6 8 ${i % 2 ? 10 : -6} 4`} fill="none" stroke="#5B3A1E" strokeWidth="3.2" strokeLinecap="round" />
    ))}
  </svg>
);

const Spots = ({ color, n = 7, bottom = true }) => (
  <div className={`absolute inset-x-[10%] ${bottom ? "bottom-[4%] h-[38%]" : "top-[8%] h-[40%]"}`} aria-hidden>
    {Array.from({ length: n }).map((_, i) => (
      <span key={i} className="absolute rounded-full" style={{ background: color, width: `${10 + (i * 7) % 14}%`, aspectRatio: "1", left: `${(i * 37) % 85}%`, top: `${(i * 53) % 70}%`, opacity: 0.8 }} />
    ))}
  </div>
);

const Bubble = ({ icon: Icon, color = "#2C4A3E" }) => (
  <span className="absolute -top-3 -right-3 w-14 h-14 rounded-full bg-white shadow-lg grid place-items-center float-up border border-[#E6DEC3]" aria-hidden>
    <Icon className="w-7 h-7" style={{ color }} />
  </span>
);

const ISSUES = {
  hair: () => <Hair />,
  dirt: () => <Spots color="#6B4423" />,
  teeth: () => <Bubble icon={Candy} color="#C87D53" />,
  sneeze: () => <><Spots color="#9BC59D" n={9} bottom={false} /><Bubble icon={Wind} color="#6B9080" /></>,
  sweat: () => <Spots color="#7FB3D5" n={8} bottom={false} />,
  shoes: () => <Bubble icon={Footprints} color="#C87D53" />,
  clock: () => <Bubble icon={Clock} />,
  sleepy: () => <><div className="absolute inset-0 bg-[#1E2A44]/35 rounded-[inherit]" /><Bubble icon={Moon} color="#3B4C7A" /></>,
  hungry: () => <Bubble icon={Utensils} color="#C87D53" />,
  angry: () => <><div className="absolute inset-0 bg-[#E05A47]/30 rounded-[inherit]" /><Bubble icon={Flame} color="#E05A47" /></>,
  share: () => <Bubble icon={Gift} color="#C87D53" />,
  sorry: () => <Bubble icon={HeartCrack} color="#C0566B" />,
  street: () => <Bubble icon={TrafficCone} color="#E07A2E" />,
  stranger: () => <Bubble icon={UserX} color="#B54848" />,
  emergency: () => <><div className="absolute inset-0 bg-[#E05A47]/15 rounded-[inherit] animate-pulse" /><Bubble icon={Siren} color="#D33B2C" /></>,
  cold: () => <><div className="absolute inset-0 bg-[#BFD4E6]/45 rounded-[inherit]" /><Bubble icon={Snowflake} color="#3B82C4" /></>,
};

export const SceneOverlay = ({ issue, fixed }) => {
  const Issue = ISSUES[issue];
  return (
    <>
      <div className={`absolute inset-0 rounded-[inherit] transition-opacity duration-700 ${fixed ? "opacity-0" : "opacity-100"}`} data-testid={`scene-overlay-${issue}`} data-fixed={fixed}>
        {Issue && <Issue />}
      </div>
      {fixed && (
        <div className="absolute inset-0 pointer-events-none" aria-hidden>
          {[[10, 15], [75, 10], [20, 70], [80, 65], [50, 5]].map(([l, t], i) => (
            <Sparkles key={i} className="absolute w-8 h-8 text-[#D99B26] sparkle-pop" style={{ left: `${l}%`, top: `${t}%`, animationDelay: `${i * 0.12}s` }} />
          ))}
        </div>
      )}
    </>
  );
};
